import { Link } from 'react-router-dom';
import { categoryMeta } from '@/mocks/resources';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 w-full bg-primary-900 text-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 md:px-8 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
              <i className="ri-play-circle-fill text-2xl" />
            </span>
            <span className="font-heading text-base font-bold text-background-50">
              国语对白做受69
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200/90">
            专注于国语对白高清影音资源的综合内容站，为影迷与研究者提供便捷的查询、浏览与了解渠道。
          </p>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold text-background-50">
            内容导航
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm">
            <li>
              <Link to="/" className="cursor-pointer text-background-200/90 transition-colors hover:text-accent-400">
                首页
              </Link>
            </li>
            <li>
              <Link to="/search" className="cursor-pointer text-background-200/90 transition-colors hover:text-accent-400">
                搜索资源
              </Link>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer text-background-200/90 transition-colors hover:text-accent-400">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold text-background-50">
            资源分类
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm">
            {categoryMeta.map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/category/${cat.slug}`}
                  className="cursor-pointer text-background-200/90 transition-colors hover:text-accent-400"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-label text-sm font-semibold text-background-50">
            联系我们
          </h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-200/90">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-400" />
              contact@gy69-media.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-accent-400" />
              内容更新：每日 09:00 - 22:00
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line text-accent-400" />
              中国 · 线上内容平台
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-200/70 sm:flex-row md:px-8">
          <p>© {year} 国语对白做受69 高清影音资源集锦 · 本站内容为前端演示展示</p>
          <p className="flex items-center gap-3">
            <span>仅作信息浏览与检索演示</span>
            <span className="hidden sm:inline">·</span>
            <span className="hidden sm:inline">请遵守当地法律法规</span>
          </p>
        </div>
      </div>
    </footer>
  );
}